import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../../components/common/Footer';

const MainLayout: React.FC = () => {
  return (
    <div className="min-h-screen text-white" style={{ backgroundColor: '#231F20' }}>
      <main className="main-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout;